import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { getLineItemList } from "../sharedCode/queries";
import { lookupOptions } from "../GQL/lookupOptions";
import { BackgroundProps, SyncStatus, TableSyncer } from "../Utils/Interfaces";
import { TicketLineItemType } from "../sharedCode/avroGraphql";
import { TicketDatabase } from "../Utils/TicketDatabase";

export default function useLineItemBackgroundPull(props: BackgroundProps): TableSyncer {
    const [status, setStatus] = useState(SyncStatus.Loading);
    const [doQuery, { loading: gqlLoading, error: gqlError, data: gqlResult, refetch: refetch }] = useLazyQuery(getLineItemList, lookupOptions);

    const fetchData = (firstRun: boolean) => {
        if (firstRun) {
            doQuery();
        } else {
            setStatus(SyncStatus.Loading);
            props.updateUi();
            refetch()
                .then((results) => {
                    const rawList = results.data.getTicketLineItemTypes.slice() as TicketLineItemType[];
                    saveToLocalDatabase(rawList);
                    setStatus(SyncStatus.Fresh);
                    props.updateUi();
                })
                .catch((e) => {
                    setStatus(SyncStatus.Stale);
                    props.updateUi();
                });
        }
    };

    function saveToLocalDatabase(rawList: TicketLineItemType[]) {
        TicketDatabase.transaction("rw", TicketDatabase.ticketLineItemType, async () => {
            await TicketDatabase.ticketLineItemType
                ?.toCollection()
                .primaryKeys()
                .then((keys) => {
                    TicketDatabase.ticketLineItemType.bulkDelete(keys);
                })
                .then(() => TicketDatabase.ticketLineItemType.bulkAdd(rawList));
        });
    }

    useEffect(() => {
        if (gqlResult) {
            const rawList = gqlResult.getTicketLineItemTypes.slice() as TicketLineItemType[];
            saveToLocalDatabase(rawList);
            setStatus(SyncStatus.Fresh);
            props.updateUi();
        }
    }, [gqlResult]);

    useEffect(() => {
        if (gqlError) {
            TicketDatabase.ticketLineItemType.count().then((c) => {
                setStatus(c > 0 ? SyncStatus.Stale : SyncStatus.Error);
                props.updateUi();
            });
        }
    }, [gqlError]);

    useEffect(() => {
        if (gqlLoading) {
            setStatus(SyncStatus.Loading);
            props.updateUi();
        }
    }, [gqlLoading]);

    return { status, fetchData: fetchData };
}
